// extracted by mini-css-extract-plugin
export default {"item":"ListItem_item__Oe9lK","title":"ListItem_title__hJOUx","description":"ListItem_description__EkXrb","list":"ListItem_list__K8tN+"};